/**
 * Service initialization state tracker
 *
 * Provides a way for components to wait for core services to initialize
 * before attempting to use them.
 */

let servicesInitialized = false;
const initializationCallbacks: Array<() => void> = [];

/**
 * Mark all services as initialized
 */
export const setServicesInitialized = (): void => {
  servicesInitialized = true;

  // Call all registered callbacks
  initializationCallbacks.forEach(callback => callback());
  initializationCallbacks.length = 0; // Clear the array
};

/**
 * Check if services are initialized
 */
export const areServicesInitialized = (): boolean => {
  return servicesInitialized;
};

/**
 * Wait for services to initialize
 * Returns a promise that resolves when services are ready
 */
export const waitForServices = (): Promise<void> => {
  if (servicesInitialized) {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    initializationCallbacks.push(resolve);
  });
};
